import { Suspense } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import { PATHS } from 'src/constants';
import {
  LoginPage,
  SignUpPage,
  SendLinkVerify,
  ForgotPasswordPage,
  ResetPasswordPage,
  DashboardPage,
  // WidgetPage,
  SigUpVerifyPage,
  // ReportedPage,
  MyReportsPage,
  AccessibilityDashboardPage,
  AutomatedAuditPage,
  AutomatedRunsPage,
  AutomatedSpecificPage,
  AccountPage,
  OnboardingPage,
  SupportPage,
  FAQPage,
  IssuePage,
  MyReportPage,
  // SitemapPage,
  SettingsPage,
  OrganizationAccessPage,
  ScanPage,
  ManageCompany,
  OrganizationCompaniesWebsite,
} from 'src/pages';
import { DashboardLayout, MainLayout, ScrollToTop } from 'src/components';
// import ManualAuditPage from 'src/pages/ManualAuditPage';
import { useAppSelector } from 'src/store';
import Reports from 'src/pages/Reports';
import Users from 'src/pages/Users';
import OrganizationCompanies from 'src/pages/OrganizationCompanies';
import OrganizationWebsites from 'src/pages/OrganizationWebsites';
import Notification from 'src/pages/Notification'
import AccountPassword from 'src/pages/AccountPassword';
import MyOrganisations from 'src/pages/MyOrganisations';
import AllClients from 'src/pages/AllClients';
import ManageUsers from 'src/pages/ManageUsers';
import ManageWesiste from 'src/pages/ManageWesiste';
import ManageTags from 'src/pages/ManageTags';
import Permissions from 'src/pages/Permissions';
import InitSelectWebsite from 'src/pages/InitSelectWebsite/page';



const AuthRoutes = (): JSX.Element => (
  <Suspense fallback={'Loading'}>
    <BrowserRouter basename={PATHS.BASENAME}>
      <ScrollToTop authFlow={true} />
      <Routes>
        <Route path={PATHS.LOGIN} element={<LoginPage />} />
        <Route path={PATHS.SIGN_UP} element={<SignUpPage />} />
        <Route path={PATHS.SEND_VERIFY_LINK} element={<SendLinkVerify />} />
        <Route path={PATHS.CONFIRM_VERIFY} element={<SigUpVerifyPage />} />
        <Route path={PATHS.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={PATHS.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route path={PATHS.ONBOARDING} element={<OnboardingPage />} />
        <Route path={'*'} element={<Navigate to={PATHS.LOGIN} replace />} />
      </Routes>
    </BrowserRouter>
  </Suspense>
);

const PrivateRoutes = (): JSX.Element => {
  const { isWebsiteOwner, isWidgetUser, isSuperAdmin } = useAppSelector((state) => state.user.data);

  return (
    <Suspense fallback={'Loading'}>
      <BrowserRouter basename={PATHS.BASENAME}>
        <ScrollToTop />
        <MainLayout>
          <Routes>
            <Route
              path={PATHS.DASHBOARD}
              element={isWebsiteOwner ? <InitSelectWebsite /> : <Navigate to={PATHS.MY_REPORTS} replace />}
            />
            <Route
              path={PATHS.MY_REPORTS}
              element={
                isWidgetUser ? (
                  <MyReportsPage />
                ) : isWebsiteOwner ? (
                  <Navigate to={PATHS.DASHBOARD} replace />
                ) : isSuperAdmin ? (
                  <Navigate to={PATHS.USERS} replace />
                ) : (
                  <Navigate to={PATHS.ACCOUNT} replace />
                )
              }
            />
            <Route
              path={PATHS.MY_REPORTS_ISSUE_ID}
              element={
                <div style={{ flexGrow: 1 }}>
                  <MyReportPage />
                </div>
              }
            />
            <Route path={`${PATHS.ACCOUNT}`} element={<AccountPage />} />
            {/* <Route path={PATHS.MANAGE_ORGANIZATION_ACCESS} element={ <OrganizationAccessPage/>} /> */}
            {/* <Route path={PATHS.COMPANIES} element={ <OrganizationCompanies/> } /> */}
            {/* <Route path={PATHS.COMPANIESWEBSITE} element={ <OrganizationCompaniesWebsite/> } /> */}
            {/* <Route path={PATHS.ORGANIZATIONWEBSITE} element={ <OrganizationWebsites/> } /> */}

            <Route path={PATHS.ACCOUNTDETAILS} element={ <AccountPage/> } />
            {/* <Route path={PATHS.PASSWORD} element={ <AccountPassword/> } /> */}
            {/* <Route path={PATHS.NOTIFICATION} element={ <Notification/> } /> */}
            <Route path={PATHS.ORGANIZATION} element={ <MyOrganisations/> } />
            <Route path={PATHS.CLIENT} element={ <AllClients/> } />
            <Route path={PATHS.MANAGEUSERS} element={ <ManageUsers/> } />
            <Route path={PATHS.MANAGEWEBSITES} element={ <ManageWesiste/> } />
            <Route path={PATHS.MANAGETAGS} element={ <ManageTags/> } />
            {/* <Route path={PATHS.PERMISSIOM} element={ <Permissions/> } /> */}




            <Route path={PATHS.SUPPORT} element={<SupportPage />} />
            <Route path={PATHS.FAQ} element={<FAQPage />} />
            <Route path={PATHS.USERS} element={<Users />} />
            <Route path={PATHS.REPORTS} element={<Reports />} />
            <Route path={PATHS.SCAN} element={<ScanPage />} />
            <Route path={'*'} element={<Navigate to={PATHS.DASHBOARD} replace />} />

            <Route path={PATHS.COMPANY} element={<ManageCompany />} />
            <Route path={PATHS.AUTOMATED_AUDIT_SELECT} element={<InitSelectWebsite />} />
            <Route path={PATHS.DASHBOARD_WRAPPER} element={<DashboardLayout />}>
              <Route path={PATHS.WIDGET} element={<Navigate to={PATHS.DASHBOARD} replace />} />
              {/* <Route path={PATHS.SITEMAP} element={<SitemapPage />} /> */}
              <Route path={PATHS.MANUAL_AUDIT} element={<Navigate to={PATHS.DASHBOARD} replace />} />
              <Route path={PATHS.AUTOMATED_AUDIT} element={<AutomatedAuditPage />} />
              {/* <Route path={PATHS.AUTOMATED_AUDIT_RUNS} element={<AutomatedRunsPage />} />
              <Route path={PATHS.AUTOMATED_AUDIT_SPECIFIC_RUN} element={<AutomatedSpecificPage />} /> */}
              <Route
                path={PATHS.REPORTED}
                element={<Navigate to={PATHS.DASHBOARD} replace />} />
              {/* <Route
                path={PATHS.ACCESSIBILITY_DASHBOARD}
                element={
                  <div style={{ flexGrow: 1 }}>
                    <AccessibilityDashboardPage />
                  </div>
                }
              /> */}
              <Route
                path={PATHS.REPORTED_ISSUE_ID}
                element={
                  <div style={{ flexGrow: 1 }}>
                    <IssuePage />
                  </div>
                }
              />
              {/* <Route path={'*'} element={<Navigate to={PATHS.ACCESSIBILITY_DASHBOARD} replace />} /> */}

              <Route path={PATHS.SETTINGS} element={<SettingsPage />} />

            </Route>
          </Routes>
        </MainLayout>
      </BrowserRouter>
    </Suspense>
  );
};


export { AuthRoutes, PrivateRoutes };
